import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LinkItem from './LinkItem';
import { useLinksContext } from '@pages/Links';
import customFetch from '@utils/customFetch';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const LinkList = () => {
  const navigate = useNavigate();
  const {
    links,
    setShowSlideIn,
    setLinkEdit,
    setEditIconValue,
    listItems,
    setListItems,
    targetUserId,
  } = useLinksContext();
  const items = links.data.links;

  useEffect(() => {
    if (listItems !== links.data.links) {
      setListItems(links.data.links);
    }
  }, [links.data.links]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleDragEnd = async (result) => {
    const { destination, source } = result;

    if (!destination || source.index === destination.index) {
      return;
    }

    const newItems = reorder(
      listItems,
      result.source.index,
      result.destination.index
    );

    for (let i = 0; i < newItems.length; i++) {
      newItems[i].position = i;
    }

    setListItems(newItems);

    try {
      const posUrl = targetUserId
        ? `/links/positions?targetUserId=${targetUserId}`
        : `/links/positions`;
      await customFetch.patch(posUrl, {
        newItems,
      });
      return null;
    } catch (error) {
      toast.error(error?.response?.data?.msg);
      return error;
    }
  };

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="lisItems">
          {(provided) => (
            <ul
              className="w-[100%]"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {listItems.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <LinkItem {...item} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
      {/* Neuer Link hinzufügen */}
      <button
        onClick={() => {
          setShowSlideIn(true);
          setLinkEdit({ new: true, position: items.length * 10000 });
          setEditIconValue('FaPhone');
        }}
        type="button"
        className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-2 text-center hover:border-gray-400 focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-500 focus:ring-offset-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1}
          stroke="currentColor"
          className="mx-auto h-12 w-12 text-gray-400"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <span className="mt-2 block text-sm font-semibold text-gray-900">
          Neuen Link erstellen
        </span>
      </button>
    </>
  );
};

export default LinkList;
